export default "__VITE_ASSET__K$jMnXHs__"